import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Divider,
  Pagination,
} from '@mui/material';
import './detailTalent.css';

const HistoriqueTab = ({ historique }) => {
  const [page, setPage] = useState(1);
  const itemsPerPage = 5; 

  if (!historique || historique.length === 0) {
    return (
      <Paper elevation={3} className="paper-box">
        <Typography variant="h6" gutterBottom>
          Historique des actions
        </Typography>
        <Typography variant="body2" className="text-secondary">
          Aucune action enregistrée.
        </Typography>
      </Paper>
    );
  }

  const sortedHistorique = historique.sort((a, b) => new Date(b.date) - new Date(a.date));
  const pageCount = Math.ceil(sortedHistorique.length / itemsPerPage);
  const startIndex = (page - 1) * itemsPerPage;
  const currentItems = sortedHistorique.slice(startIndex, startIndex + itemsPerPage);
  
  return (
    <Paper elevation={3} className="paper-box">
      <Typography variant="h6" gutterBottom>
        Historique des actions
      </Typography>

      {currentItems.map((item, i) => (
        <Box key={startIndex + i} className="historique-entry">
          <Typography variant="body2">
            {item.date
              ? new Date(item.date).toLocaleString('fr-FR')
              : 'Date inconnue'}
          </Typography>
          <Typography variant="body1" fontWeight="bold">
            {item.action}
          </Typography>
          <Divider className="divider-small" />
        </Box>
      ))}

      <Box mt={2} display="flex" justifyContent="center">
        <Pagination
          count={pageCount}
          page={page}
          onChange={(e, value) => setPage(value)}
          color="secondary"
          />

      </Box>
    </Paper>
  );
};

export default HistoriqueTab;
